<template>
  <div>
    <div v-if="showMainContainer">
      <div class="price-container">支付金额:<span>￥{{amount}}</span></div>
      <div style="padding: 10px 30px;">
        <div class="item">
          <label>卡号</label>
          <input
              type="text"
              placeholder="卡号"
              v-model="postData.pan"
          />
        </div>
        <div class="item">
          <label>类型</label>
          <select style="width: 100%" v-model="postData.cardType">
            <option value="1">借记卡</option>
            <option value="2">信用卡</option>
          </select>
        </div>
        <div class="item" v-if="postData.cardType === '2'">
          <label>有效期</label>
          <input
              type="text"
              placeholder="月份/年份 如0821"
              v-model="postData.expiredDate"
          />
        </div>
        <div class="item" v-if="postData.cardType === '2'">
          <label>CVV2</label>
          <input
              type="text"
              placeholder="卡背面签名栏后三位"
              v-model="postData.cvv2"
          />
        </div>
        <div class="item">
          <label>姓名</label>
          <input
              type="text"
              placeholder="持卡人姓名"
              v-model="postData.cardHolderName"
          />
        </div>
        <div class="item">
          <label>身份证</label>
          <input
              type="text"
              placeholder="持卡身份证号码"
              v-model="postData.cardHolderId"
          />
        </div>
        <div class="item">
          <label>手机号</label>
          <input
              type="text"
              placeholder="银行预留手机号"
              v-model="postData.phoneNo"
          />
        </div>
        <div class="item">
          <input
              type="text"
              placeholder="验证码"
              v-model="postData.validCode"
          />
          <button class="valid-code-btn" @click="getCaptcha()" :disabled="validBtnDisabled">{{ validBtn }}</button>
        </div>
        <button class="pay-btn" :disabled="payBtnDisabled" @click="payOrder()">{{ payBtn }}</button>
      </div>
    </div>
    <div v-else>
      <div class="success-container">
        <img src="~@/assets/images/success.png" alt="">
        <div class="success-text">支付成功</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrderInfo,getCaptcha,payOrder} from '@/api/api'

const btnText = '获取验证码';

const payBtnText = '支付';

const timeout = 60;

export default {
  name: "Fastpay",
  data() {
    return {
      showMainContainer: true,
      amount:'0.00',
      orderToken: '',
      ifCode: '',
      validBtnDisabled: false,
      payBtnDisabled: false,
      postData: {
        pan: '',
        cardHolderName: '',
        cardHolderId: '',
        phoneNo: '',
        cardType: 1,
        expiredDate: '',
        cvv2: '',
        token:'',
        validCode:''
      },
      validBtnTimeoutKey: -1,
      validBtnKey: -1,
      validBtn: btnText,
      payBtn: payBtnText,
      delay: timeout,
      payBtnTimeoutKey: -1,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    isMobileDevice: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    init() {
      const {ifCode, token} = this.$router.history.current.params;
      this.orderToken = token;
      this.ifCode = ifCode;
      if (token) {
        getOrderInfo(token).then(info => {
          this.amount = info.amount / 100;
        })
      }
    },
    check() {
      if (this.postData.cardType === 1) {
        if (this.postData.pan === '' ||
            this.postData.cardHolderName === '' ||
            this.postData.cardHolderId === '' ||
            this.postData.phoneNo === '') {
          return false;
        }

      } else if (this.postData.cardType === 2) {
        if (this.postData.pan === '' ||
            this.postData.cardHolderName === '' ||
            this.postData.cardHolderId === '' ||
            this.postData.phoneNo === '' ||
            this.postData.expiredDate === '' ||
            this.postData.cvv2 === '')
        {
          return false;
        }
      }
      return true;
    },
    getCaptcha(){
      console.log(this.postData)

      this.setValidBtn()

      this.validBtnTimeoutKey = setTimeout(() => {
        if (this.validBtnKey !== -1){
          clearTimeout(this.validBtnTimeoutKey)
        }

        if (this.postData.pan.length < 12){
          alert('请输入正确的银行卡号')
          return
        }

        if (this.postData.phoneNo.length < 11){
          alert('请输入正确的手机号')
          return
        }

        if (this.check()) {
          getCaptcha(this.orderToken, this.ifCode, this.postData).then(res => {
            console.log(res)
            this.postData.token = res.token
            this.setValidBtn()
          }).catch(err => {
            console.log(err)
            this.initValidBtn()
          });
        }

      },300)
    },
    setValidBtn(){
      this.validBtnDisabled = true;
      this.validBtnKey = setTimeout(() => {
        if (this.delay <= 0) {
          this.initValidBtn()
        } else {
          this.delay--
          this.validBtn = `(${this.delay}s)后重新获取`
          this.setValidBtn()
        }
      }, 1000)
    },
    initValidBtn(){
      clearTimeout(this.validBtnKey)
      this.delay = timeout
      this.validBtn = btnText
      this.validBtnKey = -1;
      this.validBtnDisabled = false;
    },
    payOrder() {
      if (this.check() && this.postData.validCode !== '' && this.postData.token !== '') {
        this.payBtnDisabled = true;
        this.payBtn = '支付中...';
        this.payBtnTimeoutKey = setTimeout(() => {
          if (this.payBtnTimeoutKey !== -1) {
            clearTimeout(this.payBtnTimeoutKey)
            this.payBtnDisabled = false;
          }

          payOrder(this.orderToken, {channelExtra: JSON.stringify(this.postData)})
              .then(res => {
                // console.log(res)
                if(res.code !== 0) {
                  return alert(`支付失败: ${res.msg}`)
                }

                if (res && res.orderState === 1) {
                  this.showMainContainer = false;
                } else {
                  if (res.data.errMsg) {
                    alert(res.data.errMsg);
                  } else {
                    alert(`支付失败: ${res.msg}`)
                  }
                }
              })
              .catch(err => {
                console.log(err)
                alert(`支付失败`)
              });
        }, 300)
      } else {
        alert('请输入验证码')
      }
    }
  },
}
</script>

<style>

.success-container {
  margin-top: 100px;
}

.price-container {
  padding: 10px 20px;
  font-size: 45px;
  background-color: papayawhip;
  margin-bottom: 18px;
}

.price-container span {
  color: red;
  margin-left: 10px;
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.item > label {
  width: 150px;
  font-size: 30px;
}

.item > input, .item > select {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px;
  font-size: 30px;
}

.valid-code-btn{
  width: 390px;
  background-color: rgba(107,154,255,1);
  border: 3px solid rgba(0,0,0,0.1);
  color: white;
  padding: 15px 0;
  margin-left: 10px;
  border-radius: 5px;
}

.valid-code-btn:active {
  background-color: rgba(107,154,255,0.6)
}

.pay-btn {
  width: 100%;
  background-color: red;
  font-size: 30px;
  color: white;
  border: 3px solid rgba(0,0,0,0.1);
  padding: 15px 0;
  border-radius: 5px;
}
.pay-btn:active {
  background-color: rgba(255,0,0,0.6);
}
</style>